import $ from 'jquery';

function extractNotice(entry) {
  if (typeof entry === 'string') {
    return entry;
  }

  if (entry && typeof entry === 'object') {
    return entry.notice || entry.message || '';
  }

  return '';
}

let noticeHideTimer = null;

function hideNoticeModal(modal) {
  const el = modal?.[0] || modal;
  const $modal = $(el);

  // Avoid aria-hidden warning: blur focused node inside the modal before hide
  const active = document.activeElement;
  if (active && el && el.contains(active)) {
    active.blur();
  }

  $modal.modal('hide');
}

function showNotices(notices, { autoHideMs = 3000 } = {}) {
  const modal = $('#abc-wc-notice-modal');
  const modalBody = modal.find('> .modal-dialog .modal-body, .modal-body').first();

  modalBody.empty();

  if (noticeHideTimer) {
    clearTimeout(noticeHideTimer);
    noticeHideTimer = null;
  }

  let hasContent = false;
  let onlySuccess = true;

  ['error', 'success', 'notice'].forEach((type) => {
    const items = notices?.[type];
    if (!items) {
      return;
    }

    if (type === 'error') {
      onlySuccess = false;
    }

    const className = {
      error: 'woocommerce-error',
      success: 'woocommerce-message',
      notice: 'woocommerce-info',
    }[type];

    Object.keys(items).forEach((key) => {
      const text = extractNotice(items[key]);
      if (!text) {
        return;
      }

      hasContent = true;
      $('<div>').addClass(className).html(text).appendTo(modalBody);
    });
  });

  if (hasContent) {
    modal.off('hide.bs.modal.abcA11y').on('hide.bs.modal.abcA11y', function () {
      const active = document.activeElement;
      if (active && this.contains(active)) {
        active.blur();
      }
    });

    modal.modal('show');

    // Success/info notices close automatically; errors stay until Ok
    if (autoHideMs > 0 && onlySuccess) {
      noticeHideTimer = setTimeout(() => {
        hideNoticeModal(modal);
        noticeHideTimer = null;
      }, autoHideMs);
    }
  }

  return hasContent;
}

function initPostcodeChecker() {
  const addressCheckerModal = $('.abc-widget-postcode-checker__modal');
  const stickySidebar = $('.sticky-sidebar');

  if (!addressCheckerModal.length || typeof addressCheckerModal.modal !== 'function') {
    return;
  }

  addressCheckerModal.modal({ show: false, backdrop: 'static' });
  addressCheckerModal.on('hidden.bs.modal', () => {
    stickySidebar.addClass('sticky-sidebar');
  });

  const postcode = localStorage.getItem('abc-postcode');

  if (postcode) {
    $('.abc-widget-postcode-checker__postcode').val(postcode);
    $('.abc-widget-postcode-checker__notice').html('We kunnen hier bezorgen');
  } else {
    addressCheckerModal.modal('show');
    stickySidebar.removeClass('sticky-sidebar');
  }

  $('.abc-widget-postcode-checker__button').off('click.abcPostcode').on('click.abcPostcode', function () {
    const noticeModal = $('#abc-wc-notice-modal');
    const modalBody = noticeModal.find('.modal-body').first();
    modalBody.empty();

    const inputPostcode = $('.abc-widget-postcode-checker__postcode', $(this).parents('.abc-widget-postcode-checker__container'));
    const notice = $('.abc-widget-postcode-checker__notice');
    notice.empty();

    const showMessage = (className, message) => {
      $('<div>').addClass(className).html(message).appendTo(modalBody);
      noticeModal.modal('show');
    };

    if (inputPostcode.val().length === 0) {
      showMessage('woocommerce-error', 'Voer een postcode in');
      return;
    }

    if (!inputPostcode[0].checkValidity()) {
      showMessage('woocommerce-error', 'Voer een geldige postcode in');
      return;
    }

    if (window.checkZones(inputPostcode.val(), inputPostcode.data('zone-location-codes'), window.checkZoneLocationCode)) {
      showMessage('woocommerce-message', 'We kunnen hier bezorgen');
      $('<div>').addClass('woocommerce-message').html('We kunnen hier bezorgen').appendTo(notice);
      addressCheckerModal.modal('hide');
      localStorage.setItem('abc-postcode', inputPostcode.val());
      $('.abc-widget-postcode-checker__postcode').val(inputPostcode.val());
    } else {
      showMessage('woocommerce-error', 'Helaas kunnen we hier niet bezorgen');
      $('<div>').addClass('woocommerce-error').html('Helaas kunnen we hier niet bezorgen').appendTo(notice);
      localStorage.removeItem('abc-postcode');
    }
  });
}

export default {
  init() {
    window.checkZoneLocationCode = function (postcode, zoneLocationCode) {
      postcode = parseInt(postcode, 10);

      let regExp = /^\d+\.{3}\d+$/i;

      if (zoneLocationCode.match(regExp)) {
        const zoneLocationCodeRange = zoneLocationCode.split('...');

        if (postcode >= parseInt(zoneLocationCodeRange[0], 10) && postcode <= parseInt(zoneLocationCodeRange[1], 10)) {
          return true;
        }
      }

      if (zoneLocationCode.includes('*')) {
        regExp = new RegExp(`^${zoneLocationCode.replace(/\*/g, '\\d')}$`);

        if (String(postcode).match(regExp)) {
          return true;
        }
      }

      return postcode === parseInt(zoneLocationCode, 10);
    };

    window.checkZones = function (postcode, zoneLocationCodes, func) {
      for (const i in zoneLocationCodes) {
        if (func(postcode, zoneLocationCodes[i])) {
          return true;
        }
      }

      return false;
    };

    window.addToCartRequest = function (productId, productPermalink) {
      const productModal = $(`#abc-wc-product-modal-${productId}`);
      const form = $('form', productModal);

      if (!form.length || !form[0]) {
        showNotices({
          error: [{ notice: 'Kon het productformulier niet vinden. Vernieuw de pagina en probeer opnieuw.' }],
        });
        return;
      }

      const formData = new FormData(form[0]);
      formData.append('add-to-cart', productId);

      const qty = Math.max(1, parseInt(formData.get('quantity') || form.find('[name="quantity"]').val() || 1, 10) || 1);
      const productName = $(`#abc-wc-product-${productId} .abc-wc-product-category__product-name`)
        .clone()
        .children()
        .remove()
        .end()
        .text()
        .replace(/\u00a0/g, ' ')
        .trim() || 'Product';

      const buildSuccessNotice = () => {
        const qtyPrefix = qty > 1 ? `${qty} × ` : '';
        return `${qtyPrefix}“${productName}” is toegevoegd aan je winkelmandje.`;
      };

      $('.add-to-cart-button', productModal).attr('disabled', 'disabled');

      fetch(productPermalink, {
        body: formData,
        method: 'POST',
        credentials: 'same-origin',
      })
        .then(async (r) => {
          const text = await r.text();
          try {
            return JSON.parse(text);
          } catch (e) {
            throw new Error('Ongeldige serverrespons bij toevoegen aan het winkelmandje.');
          }
        })
        .then((o) => {
          $('.add-to-cart-button', productModal).removeAttr('disabled');

          const notices = Array.isArray(o) ? {} : (o || {});
          let hasContent = showNotices(notices);

          // Server returned no usable notice but add-to-cart succeeded
          if (!hasContent && typeof notices.error === 'undefined') {
            hasContent = showNotices({
              success: [{ notice: buildSuccessNotice() }],
            });
          }

          if (typeof notices.error === 'undefined') {
            productModal.modal('hide');
            window.refreshCart();
          }
        })
        .catch((err) => {
          $('.add-to-cart-button', productModal).removeAttr('disabled');
          showNotices({
            error: [{ notice: err.message || 'Er ging iets mis bij het toevoegen aan het winkelmandje.' }],
          });
        });
    };

    window.refreshCart = function () {
      if (!window.wc_cart_fragments_params?.wc_ajax_url) {
        return;
      }

      $.ajax({
        url: window.wc_cart_fragments_params.wc_ajax_url
          .toString()
          .replace('%%endpoint%%', 'get_refreshed_fragments'),
        type: 'POST',
        success(data) {
          if (data && data.fragments) {
            $.each(data.fragments, (key, value) => {
              $(key).replaceWith(value);
            });

            $(document.body).trigger('wc_fragments_refreshed');
          }
        },
      });
    };

    // Vite ES modules often run after window "load" already fired — don't wait for it.
    initPostcodeChecker();
  },
  finalize() {
    // JavaScript to be fired on the winkel page, after the init JS
  },
};
